import React from "react";
import { graphql } from "gatsby";
import { CallOutBanner as CallOutBannerComponent } from "@zempler/theme/src/components/callOutBanner/CallOutBanner";
import { NestedComponentRenderer } from "../../NestedComponentRenderer";

export const CallOutBanner = ({ data, ...rest }) => {
  const nestedComponents = data.components?.map((item) => {
    const { component } = item;

    return {
      ...component,
      areas: undefined
    };
  });



  return (
  <CallOutBannerComponent {...data} style={data.style?.toLowerCase()}>
    <NestedComponentRenderer components={nestedComponents} />
  </CallOutBannerComponent>
)};

export const CallOutBannerQuery = graphql`
  fragment CallOutBanner on UMBRACO_CallOutBannerComponentType {
    heading
    icon
    backgroundColor
    style
    components {
      component {
        ...CallOutBannerComponents 
      }
    }
  }
`;
